import { all } from 'redux-saga/effects';

import { patientTherapyListSagas } from './patientTherapyListSagas';
import { patientTherapySagas } from './patientTherapySagas';

export function* therapySagaWatcher() {
  yield all([...patientTherapyListSagas, ...patientTherapySagas]);
}
